import React, { useState } from 'react';
import { api } from '../api';
import Layout from '../components/Layout';

const initialConcept = null;

export default function CreateImages() {
  const [landingPageUrl, setLandingPageUrl] = useState('');
  const [landingPageUrl2, setLandingPageUrl2] = useState('');
  const [landingPageUrl3, setLandingPageUrl3] = useState('');
  const [instruction, setInstruction] = useState('');

  const [ctaMobileNumber, setCtaMobileNumber] =
    useState('9403553750');

  const [footerText, setFooterText] =
    useState('');

  const [concept, setConcept] = useState(initialConcept);
  const [keywordData, setKeywordData] = useState(null);
  const [selectedCalloutIndexes, setSelectedCalloutIndexes] = useState([]);
  const [calloutsFinalized, setCalloutsFinalized] = useState(false);

  const [analyzing, setAnalyzing] = useState(false);
  const [generating, setGenerating] = useState(false);

const [generatedCreative, setGeneratedCreative] = useState(null);

const [variantCount, setVariantCount] = useState(3);
const [facebookCopied, setFacebookCopied] = useState(null);
const [generatingVariants, setGeneratingVariants] = useState(false);
const [variantProgress, setVariantProgress] = useState({
  current: 0,
  total: 0,
});
const [activeVariantNumber, setActiveVariantNumber] = useState(null);
const [variantCreatives, setVariantCreatives] = useState([]);

const [imageQuality, setImageQuality] = useState('low');

const [error, setError] = useState('');

  const handleAnalyze = async (event) => {
    event.preventDefault();

setError('');
setConcept(null);
setCalloutsFinalized(false);
setGeneratedCreative(null);
setVariantCreatives([]);
setVariantProgress({ current: 0, total: 0 });


    const landingPageUrls = [
      landingPageUrl.trim(),
      landingPageUrl2.trim(),
      landingPageUrl3.trim(),
    ].filter(Boolean);

    const creativeInstruction = instruction.trim();

    if (landingPageUrls.length === 0 && !creativeInstruction) {
      setError(
        'Enter at least one landing page URL or provide a Creative Instruction.'
      );
      return;
    }

    try {
      setAnalyzing(true);

      let positiveKeywords = [];

      /*
       * Keyword intelligence requires a source URL.
       * In instruction-only mode, the Creative Director
       * will work from the user's brief instead.
       */
      if (landingPageUrls.length > 0) {
        const keywordResult = await api.suggestKeywords({
          landing_page_url: landingPageUrls[0],
          brand: 'Shahi Raj',
          idea_description: creativeInstruction,
        });

        setKeywordData(keywordResult);

        positiveKeywords = [
          ...(keywordResult?.exact_match || []),
          ...(keywordResult?.phrase_match || []),
        ];
      } else {
        setKeywordData(null);
      }

      /*
       * Step 2:
       * Ask the Creative Director to develop the actual
       * advertising concept.
       */
      const conceptResult = await api.creativeDirectorConcept({
        landing_page_url: landingPageUrl.trim(),
        landing_page_urls: landingPageUrls,
        instruction: creativeInstruction,
        keywords: positiveKeywords,
      });

      if (!conceptResult?.success || !conceptResult?.concept) {
        throw new Error('Creative Director did not return a valid concept.');
      }

      setConcept(conceptResult.concept);

      setSelectedCalloutIndexes(
        Array.isArray(conceptResult.concept?.selected_callout_indexes)
          ? conceptResult.concept.selected_callout_indexes
          : []
      );
    } catch (err) {
      console.error('Creative concept error:', err);
      setError(err.message || 'Unable to create the advertising concept.');
    } finally {
      setAnalyzing(false);
    }
  };

  const copyFacebookPost = async (post, key) => {
    if (!post) return;

    try {
      await navigator.clipboard.writeText(post);
      setFacebookCopied(key);

      window.setTimeout(() => {
        setFacebookCopied((current) =>
          current === key ? null : current
        );
      }, 2000);
    } catch (error) {
      console.error(
        'Failed to copy Facebook post:',
        error
      );
    }
  };

  const handleGenerate = async () => {
    if (!concept) {
      setError('Create the advertising concept first.');
      return;
    }

    if (!calloutsFinalized) {
      setError('Finalize at least 5 callouts before generating the creative.');
      return;
    }

    if (
      !Array.isArray(concept.callouts) ||
      concept.callouts.length < 5
    ) {
      setError('The finalized concept must contain at least 5 callouts.');
      return;
    }

    setError('');
    setGeneratedCreative(null);

    try {
      setGenerating(true);

      const result = await api.generateCreative({
        landing_page_url: landingPageUrl.trim(),
        landing_page_urls: [
          landingPageUrl.trim(),
          landingPageUrl2.trim(),
          landingPageUrl3.trim(),
        ].filter(Boolean),
        instruction: instruction.trim(),
        keywords: keywordData
          ? [
              ...(keywordData.exact_match || []),
              ...(keywordData.phrase_match || []),
            ]
          : [],
        concept,
        quality: imageQuality,
        cta_mobile_number: ctaMobileNumber.trim(),
        footer_text: footerText.trim(),
      });

      if (!result?.success) {
        throw new Error(
          result?.error || 'Creative generation failed.'
        );
      }

      if (!result?.creative?.image_url) {
        throw new Error('Creative was generated but no image URL was returned.');
      }

      setGeneratedCreative(result.creative);
    } catch (err) {
      console.error('Creative generation error:', err);
      setError(err.message || 'Unable to generate the creative.');
    } finally {
      setGenerating(false);
    }
  };

const handleGenerateVariants = async () => {
  if (!concept) {
    setError('Create Creative #1 first.');
    return;
  }

  if (!generatedCreative) {
    setError('Generate Creative #1 first.');
    return;
  }

  if (!calloutsFinalized) {
    setError('Finalize at least 5 callouts before generating variants.');
    return;
  }

  setError('');
  setVariantCreatives([]);
  setVariantProgress({
    current: 0,
    total: Number(variantCount),
  });

  try {
    setGeneratingVariants(true);

    const keywords = keywordData
      ? [
          ...(keywordData.exact_match || []),
          ...(keywordData.phrase_match || []),
        ]
      : [];

    const result = await api.generateCreativeVariants({
      landing_page_url: landingPageUrl.trim(),
      landing_page_urls: [
        landingPageUrl.trim(),
        landingPageUrl2.trim(),
        landingPageUrl3.trim(),
      ].filter(Boolean),
      instruction: instruction.trim(),
      keywords,
      concept,
      campaign_id:
        generatedCreative.campaign_id ||
        generatedCreative.metadata?.campaign_id ||
        undefined,
      count: Number(variantCount),
      quality: imageQuality,
      cta_mobile_number: ctaMobileNumber.trim(),
      footer_text: footerText.trim(),
    });

    if (!result?.success || !result?.job_id) {
      throw new Error(
        result?.error || 'The server did not return a variant job ID.'
      );
    }

    const jobId = result.job_id;
    let finished = false;

    while (!finished) {
      const statusResult = await api.getCreativeVariantJob(jobId);

      if (!statusResult?.success || !statusResult?.job) {
        throw new Error(
          statusResult?.error || 'Unable to retrieve variant job status.'
        );
      }

      const job = statusResult.job;
      const completedCreatives = Array.isArray(job.creatives)
        ? job.creatives
        : [];

      setVariantCreatives(completedCreatives);
      setVariantProgress({
        current: Number(job.completed_count) || completedCreatives.length,
        total: Number(job.requested_count) || Number(variantCount),
      });
      setActiveVariantNumber(
        job.current_variant ? Number(job.current_variant) - 1 : null
      );

      if (job.status === 'completed') {
        finished = true;
        break;
      }

      if (
        job.status === 'failed' ||
        job.status === 'partial_failed'
      ) {
        finished = true;

        if (job.error) {
          setError(
            completedCreatives.length > 0
              ? `${completedCreatives.length} variant(s) completed, but generation stopped: ${job.error}`
              : job.error
          );
        } else if (completedCreatives.length === 0) {
          setError('Variant generation failed.');
        }

        break;
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));
    }
  } catch (err) {
    console.error('Creative variant generation error:', err);
    setError(
      err.message || 'Unable to retrieve creative variant progress.'
    );
  } finally {
    setGeneratingVariants(false);
    setActiveVariantNumber(null);
  }
};


const updateConceptField = (field, value) => {
  setConcept((current) => ({
    ...(current || {}),
    [field]: value,
  }));
};

const invalidateCalloutFinalization = () => {
  setCalloutsFinalized(false);
  setGeneratedCreative(null);
  setVariantCreatives([]);
};

const updateCalloutCandidate = (index, field, value) => {
  invalidateCalloutFinalization();

  setConcept((current) => {
    if (!current) return current;

    const candidates = [...(current.callout_candidates || [])];
    candidates[index] = {
      ...candidates[index],
      [field]: value,
    };

    return { ...current, callout_candidates: candidates };
  });
};

const addCalloutCandidate = () => {
  invalidateCalloutFinalization();

  setConcept((current) => {
    if (!current) return current;

    return {
      ...current,
      callout_candidates: [
        ...(current.callout_candidates || []),
        { text: '', importance: 'secondary', style: 'label' },
      ],
    };
  });
};

const removeCalloutCandidate = (index) => {
  invalidateCalloutFinalization();

  setConcept((current) => {
    if (!current) return current;

    return {
      ...current,
      callout_candidates: (current.callout_candidates || [])
        .filter((_, i) => i !== index),
    };
  });

  setSelectedCalloutIndexes((current) =>
    current
      .filter((i) => i !== index)
      .map((i) => (i > index ? i - 1 : i))
  );
};

const toggleCalloutCandidate = (index) => {
  invalidateCalloutFinalization();

  setSelectedCalloutIndexes((current) =>
    current.includes(index)
      ? current.filter((item) => item !== index)
      : [...current, index]
  );
};

const handleFinalizeCallouts = async () => {
  if (!concept) {
    setError('Create the advertising concept first.');
    return;
  }

  if (selectedCalloutIndexes.length < 5) {
    setError('Select at least 5 callouts before finalizing.');
    return;
  }

  setError('');

  try {
    const result = await api.finalizeCreativeConcept({
      concept,
      selected_callout_indexes: selectedCalloutIndexes,
    });

    if (!result?.success || !result?.concept) {
      throw new Error(
        result?.error || 'Unable to finalize the callout selection.'
      );
    }

    setConcept(result.concept);
    setSelectedCalloutIndexes(
      Array.isArray(result.concept.selected_callout_indexes)
        ? result.concept.selected_callout_indexes
        : selectedCalloutIndexes
    );
    setCalloutsFinalized(true);
  } catch (err) {
    console.error('Callout finalization error:', err);
    setError(
      err.message || 'Unable to finalize the callout selection.'
    );
  }
};

const updateThingToAvoid = (index, value) => {
  setConcept((current) => {
    if (!current) return current;

    const items = Array.isArray(current.things_to_avoid)
      ? [...current.things_to_avoid]
      : [];

    items[index] = value;

    return {
      ...current,
      things_to_avoid: items,
    };
  });
};

const addThingToAvoid = () => {
  setConcept((current) => {
    if (!current) return current;

    const items = Array.isArray(current.things_to_avoid)
      ? [...current.things_to_avoid]
      : [];

    items.push('');

    return {
      ...current,
      things_to_avoid: items,
    };
  });
};

const deleteThingToAvoid = (index) => {
  setConcept((current) => {
    if (!current) return current;

    const items = Array.isArray(current.things_to_avoid)
      ? [...current.things_to_avoid]
      : [];

    items.splice(index, 1);

    return {
      ...current,
      things_to_avoid: items,
    };
  });
};

const resetConcept = () => {
  setConcept(null);
  setSelectedCalloutIndexes([]);
  setCalloutsFinalized(false);
  setGeneratedCreative(null);
  setVariantCreatives([]);
  setVariantProgress({ current: 0, total: 0 });
  setKeywordData(null);
  setError('');
};

  return (
   <Layout>
    <div className="space-y-8">
      {/* Page heading */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">
          Create Images
        </h1>

        <p className="mt-1 text-sm text-gray-500">
          Create premium advertising creatives from a landing page and
          optional creative direction.
        </p>
      </div>

      {/* Creation form */}
      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <form onSubmit={handleAnalyze} className="space-y-5">
          <div>
            <label
              htmlFor="landingPageUrl"
              className="block text-sm font-medium text-gray-700"
            >
              Landing Page URL
            </label>

            <input
              id="landingPageUrl"
              type="url"
              value={landingPageUrl}
              onChange={(event) => setLandingPageUrl(event.target.value)}
              placeholder="https://shahiraj.com/..."
              className="mt-2 block w-full rounded-lg border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
            />
          </div>

          <div>
            <label
              htmlFor="landingPageUrl2"
              className="block text-sm font-medium text-gray-700"
            >
              Landing Page URL 2
              <span className="ml-1 font-normal text-gray-400">
                (optional)
              </span>
            </label>

            <input
              id="landingPageUrl2"
              type="url"
              value={landingPageUrl2}
              onChange={(event) => setLandingPageUrl2(event.target.value)}
              placeholder="https://..."
              className="mt-2 block w-full rounded-lg border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
            />

            <p className="mt-1 text-xs text-gray-500">
              Add a second source page when the campaign or product information
              is spread across multiple pages.
            </p>
          </div>

          <div>
            <label
              htmlFor="landingPageUrl3"
              className="block text-sm font-medium text-gray-700"
            >
              Landing Page URL 3
              <span className="ml-1 font-normal text-gray-400">
                (optional)
              </span>
            </label>

            <input
              id="landingPageUrl3"
              type="url"
              value={landingPageUrl3}
              onChange={(event) => setLandingPageUrl3(event.target.value)}
              placeholder="https://..."
              className="mt-2 block w-full rounded-lg border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
            />

            <p className="mt-1 text-xs text-gray-500">
              Add a third source page when additional supporting facts are
              needed.
            </p>
          </div>

          <div>
            <label
              htmlFor="ctaMobileNumber"
              className="block text-sm font-medium text-gray-700"
            >
              CTA Mobile Number
            </label>

            <input
              id="ctaMobileNumber"
              type="tel"
              value={ctaMobileNumber}
              onChange={(event) =>
                setCtaMobileNumber(event.target.value)
              }
              placeholder="9403553750"
              className="mt-2 block w-full rounded-lg border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
            />

            <p className="mt-1 text-xs text-gray-500">
              This number will appear below the CTA on the final creative.
            </p>
          </div>

          <div>
            <label
              htmlFor="footerText"
              className="block text-sm font-medium text-gray-700"
            >
              Footer
            </label>

            <input
              id="footerText"
              type="text"
              value={footerText}
              onChange={(event) =>
                setFooterText(event.target.value)
              }
              placeholder="Leave blank for Shahi Raj logo + shahiraj.com"
              className="mt-2 block w-full rounded-lg border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
            />

            <p className="mt-1 text-xs text-gray-500">
              Leave blank to use the default Shahi Raj logo and shahiraj.com.
              Enter text to replace the entire default footer.
            </p>
          </div>

          <div>
            <label
              htmlFor="creativeInstruction"
              className="block text-sm font-medium text-gray-700"
            >
              Creative Instruction
              <span className="ml-1 font-normal text-gray-400">
                (optional)
              </span>
            </label>

            <textarea
              id="creativeInstruction"
              value={instruction}
              onChange={(event) => setInstruction(event.target.value)}
              placeholder="For example: Focus on WhatsApp automation for Indian businesses. Make it premium and suitable for LinkedIn advertising."
              rows={4}
              className="mt-2 block w-full resize-y rounded-lg border border-gray-300 px-4 py-3 text-sm outline-none transition focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
            />
          </div>

          {error && (
            <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <div className="flex items-center gap-3">
            <button
              type="submit"
              disabled={analyzing || generating}
              className="rounded-lg bg-gray-900 px-5 py-3 text-sm font-medium text-white transition hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {analyzing ? 'Analyzing & Creating Concept...' : 'Analyze & Create Concept'}
            </button>

            {(concept || generatedCreative) && (
              <button
                type="button"
                onClick={resetConcept}
                disabled={analyzing || generating}
                className="rounded-lg border border-gray-300 px-5 py-3 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Start Over
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Concept preview */}
      {concept && (
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 px-6 py-5">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-900">
                  Advertising Concept
                </h2>

                <p className="mt-1 text-sm text-gray-500">
                  Review the concept before generating the final artwork.
                </p>
              </div>

            </div>
          </div>

          <div className="grid gap-6 p-6 lg:grid-cols-2">

            {/* ====================================================
                SOURCE MATERIAL
               ==================================================== */}

            {Array.isArray(concept.source_material) &&
              concept.source_material.length > 0 && (
                <div className="lg:col-span-2">
                  <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Source Material
                  </div>

                  <p className="mt-1 text-xs text-gray-500">
                    Information extracted from the supplied landing pages.
                    This is the factual basis used by the Creative Director.
                  </p>

                  <div className="mt-4 space-y-3">
                    {concept.source_material.map((source, index) => (
                      <div
                        key={`source-material-${index}`}
                        className="rounded-lg border border-gray-200 bg-gray-50 p-4"
                      >
                        <div className="flex flex-col gap-2">
                          <div className="flex items-center gap-2">
                            <span className="rounded-full bg-gray-200 px-2 py-1 text-xs font-semibold text-gray-700">
                              Source {index + 1}
                            </span>

                            {source.role && (
                              <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
                                {source.role}
                              </span>
                            )}
                          </div>

                          {source.url && (
                            <div className="break-all text-sm font-medium text-gray-900">
                              {source.url}
                            </div>
                          )}

                          {Array.isArray(source.key_facts) &&
                            source.key_facts.length > 0 && (
                              <div className="mt-1 space-y-1">
                                {source.key_facts.map((fact, factIndex) => (
                                  <div
                                    key={`source-${index}-fact-${factIndex}`}
                                    className="text-sm leading-6 text-gray-700"
                                  >
                                    • {fact}
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {/* ====================================================
                CONSOLIDATED FACTS
               ==================================================== */}

            {Array.isArray(concept.consolidated_facts) &&
              concept.consolidated_facts.length > 0 && (
                <div className="lg:col-span-2">
                  <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Consolidated Facts
                  </div>

                  <p className="mt-1 text-xs text-gray-500">
                    Facts consolidated across all supplied sources. These can
                    be used to select accurate advertising callouts.
                  </p>

                  <div className="mt-4 space-y-3">
                    {concept.consolidated_facts.map((fact, index) => (
                      <div
                        key={`consolidated-fact-${index}`}
                        className="rounded-lg border border-gray-200 bg-white p-4"
                      >
                        <div className="text-sm leading-6 text-gray-900">
                          {typeof fact === 'string'
                            ? fact
                            : fact.fact || fact.text || ''}
                        </div>

                        {Array.isArray(fact.source_numbers) &&
                          fact.source_numbers.length > 0 && (
                            <div className="mt-2 text-xs font-medium text-gray-500">
                              Sources:{' '}
                              {fact.source_numbers
                                .map((sourceNumber) => `Source ${sourceNumber}`)
                                .join(', ')}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

            <EditableConceptField
              label="Advertising Angle"
              value={concept.advertising_angle}
              onChange={(value) =>
                updateConceptField('advertising_angle', value)
              }
            />

            <EditableConceptField
              label="Creative Concept"
              value={concept.creative_concept}
              onChange={(value) =>
                updateConceptField('creative_concept', value)
              }
            />

            <EditableConceptField
              label="Visual Story"
              value={concept.visual_story}
              onChange={(value) =>
                updateConceptField('visual_story', value)
              }
            />

            <EditableConceptField
              label="Visual Style"
              value={concept.visual_style}
              onChange={(value) =>
                updateConceptField('visual_style', value)
              }
            />

            <EditableConceptField
              label="Subject"
              value={concept.subject}
              onChange={(value) =>
                updateConceptField('subject', value)
              }
            />

            <EditableConceptField
              label="Environment"
              value={concept.environment}
              onChange={(value) =>
                updateConceptField('environment', value)
              }
            />

            <EditableConceptField
              label="Composition"
              value={concept.composition}
              onChange={(value) =>
                updateConceptField('composition', value)
              }
            />

            <EditableConceptField
              label="Lighting"
              value={concept.lighting}
              onChange={(value) =>
                updateConceptField('lighting', value)
              }
            />

            <div className="lg:col-span-2">
              <EditableConceptField
                label="Headline"
                value={concept.headline}
                emphasis
                onChange={(value) =>
                  updateConceptField('headline', value)
                }
              />
            </div>

            <div className="lg:col-span-2">
              <EditableConceptField
                label="Supporting Copy"
                value={concept.supporting_copy}
                onChange={(value) =>
                  updateConceptField('supporting_copy', value)
                }
              />
            </div>

            <div className="lg:col-span-2">
              <EditableConceptField
                label="CTA"
                value={concept.cta}
                onChange={(value) =>
                  updateConceptField('cta', value)
                }
              />
            </div>

            {/* ====================================================
                CALLOUT CANDIDATE SELECTION
               ==================================================== */}

            {Array.isArray(concept.callout_candidates) && (
              <div className="lg:col-span-2">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                      Callout Candidates
                    </div>
                    <p className="mt-1 text-xs text-gray-500">
                      Edit, add or remove candidates. Select at least 5.
                      Up to 7 will be randomly rendered in each creative.
                    </p>
                  </div>

                  <div className={`shrink-0 text-xs font-semibold ${
                    selectedCalloutIndexes.length >= 5
                      ? 'text-gray-700'
                      : 'text-red-600'
                  }`}>
                    {selectedCalloutIndexes.length} selected
                  </div>
                </div>

                <div className="mt-4 space-y-3">
                  {concept.callout_candidates.map((candidate, index) => {
                    const selected = selectedCalloutIndexes.includes(index);

                    return (
                      <div
                        key={`callout-candidate-${index}`}
                        className={`rounded-lg border p-4 transition ${
                          selected
                            ? 'border-gray-900 bg-gray-50'
                            : 'border-gray-200 bg-white'
                        }`}
                      >
                        <div className="flex items-start gap-3">
                          <input
                            type="checkbox"
                            aria-label={`Select candidate ${index + 1}`}
                            checked={selected}
                            onChange={() => toggleCalloutCandidate(index)}
                            className="mt-2 h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-900"
                          />

                          <div className="min-w-0 flex-1">
                            <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
                              Candidate {index + 1}
                            </div>

                            <textarea
                              aria-label={`Candidate ${index + 1} text`}
                              value={candidate.text || ''}
                              onChange={(event) =>
                                updateCalloutCandidate(
                                  index, 'text', event.target.value
                                )
                              }
                              rows={2}
                              className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm leading-6 text-gray-900 focus:border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-500"
                            />

                            <div className="mt-2 grid gap-3 sm:grid-cols-2">
                              <label className="text-xs text-gray-500">
                                Importance
                                <select
                                  value={candidate.importance || 'secondary'}
                                  onChange={(event) =>
                                    updateCalloutCandidate(
                                      index, 'importance', event.target.value
                                    )
                                  }
                                  className="mt-1 block w-full rounded border border-gray-300 bg-white px-2 py-2 text-sm text-gray-800"
                                >
                                  <option value="primary">Primary</option>
                                  <option value="secondary">Secondary</option>
                                </select>
                              </label>

                              <label className="text-xs text-gray-500">
                                Style
                                <select
                                  value={candidate.style || 'label'}
                                  onChange={(event) =>
                                    updateCalloutCandidate(
                                      index, 'style', event.target.value
                                    )
                                  }
                                  className="mt-1 block w-full rounded border border-gray-300 bg-white px-2 py-2 text-sm text-gray-800"
                                >
                                  <option value="label">Label</option>
                                  <option value="annotation">Annotation</option>
                                  <option value="badge">Badge</option>
                                  <option value="card">Card</option>
                                  <option value="typography">Typography</option>
                                </select>
                              </label>
                            </div>

                            {Array.isArray(candidate.source_numbers) &&
                              candidate.source_numbers.length > 0 && (
                                <div className="mt-2 text-xs font-medium text-gray-500">
                                  Sources: {candidate.source_numbers
                                    .map((n) => `Source ${n}`)
                                    .join(', ')}
                                </div>
                              )}
                          </div>

                          <button
                            type="button"
                            onClick={() => removeCalloutCandidate(index)}
                            className="shrink-0 rounded border border-gray-300 px-2 py-1 text-xs text-gray-600 hover:bg-gray-100"
                            aria-label={`Remove candidate ${index + 1}`}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <button
                  type="button"
                  onClick={addCalloutCandidate}
                  className="mt-3 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                  + Add Candidate
                </button>

                <div className="mt-3">
                  {selectedCalloutIndexes.length < 5 ? (
                    <span className="text-xs font-medium text-red-600">
                      Select at least 5 callouts.
                    </span>
                  ) : (
                    <span className="text-xs font-medium text-gray-500">
                      {selectedCalloutIndexes.length} selected.
                      Each creative will render up to 7.
                    </span>
                  )}
                </div>

                <div className="mt-4 flex items-center justify-between gap-4">
                  <div className="text-xs text-gray-500">
                    {calloutsFinalized
                      ? 'Callout selection finalized.'
                      : 'Only finalized callouts will be used in the creative.'}
                  </div>

                  {calloutsFinalized ? (
                    <button
                      type="button"
                      onClick={() => {
                        setCalloutsFinalized(false);
                        setGeneratedCreative(null);
                      }}
                      className="rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Change Selection
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleFinalizeCallouts}
                      disabled={selectedCalloutIndexes.length < 5}
                      className="rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Finalize Callout Selection
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* ====================================================
                FINAL CALLOUTS
               ==================================================== */}

            {calloutsFinalized &&
              Array.isArray(concept.callouts) &&
              concept.callouts.length > 0 && (
                <div className="lg:col-span-2">
                  <div className="flex items-center justify-between gap-4">
                    <div>
                      <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Final Callouts
                      </div>

                      <p className="mt-1 text-xs text-gray-500">
                        These are the selected factual callouts available for random selection
                        in the final creative.
                      </p>
                    </div>

                    <div className="text-xs font-semibold text-gray-700">
                      {concept.callouts.length} selected
                    </div>
                  </div>

                  <div className="mt-4 grid gap-3 sm:grid-cols-2">
                    {concept.callouts.map((callout, index) => (
                      <div
                        key={`final-callout-${index}`}
                        className="rounded-lg border border-gray-200 bg-gray-50 p-4"
                      >
                        <div className="text-xs font-semibold uppercase tracking-wide text-gray-400">
                          Callout {index + 1}
                        </div>

                        <div className="mt-2 text-sm leading-6 text-gray-900">
                          {callout.text || ''}
                        </div>

                        {callout.importance && (
                          <div className="mt-2 text-xs font-medium text-gray-500">
                            Importance: {callout.importance}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {/* ====================================================
                THINGS TO AVOID
               ==================================================== */}

            <div className="lg:col-span-2">
              <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                Things to Avoid
              </div>

              <div className="mt-3 space-y-3">
                {(Array.isArray(concept.things_to_avoid)
                  ? concept.things_to_avoid
                  : []
                ).map((item, index) => (
                  <div
                    key={`avoid-${index}`}
                    className="flex items-center gap-3"
                  >
                    <input
                      type="text"
                      value={item || ''}
                      onChange={(event) =>
                        updateThingToAvoid(
                          index,
                          event.target.value
                        )
                      }
                      className="flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                    />

                    <button
                      type="button"
                      onClick={() =>
                        deleteThingToAvoid(index)
                      }
                      className="rounded-lg border border-gray-300 px-3 py-2 text-xs font-medium text-gray-700 transition hover:bg-gray-50"
                    >
                      Delete
                    </button>
                  </div>
                ))}
              </div>

              <button
                type="button"
                onClick={addThingToAvoid}
                className="mt-3 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
              >
                + Add
              </button>
            </div>

          </div>

          <div className="border-t border-gray-200 px-6 py-5">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">

              <div>
                <label
                  htmlFor="imageQuality"
                  className="block text-xs font-semibold uppercase tracking-wide text-gray-500"
                >
                  Image Quality
                </label>

                <select
                  id="imageQuality"
                  value={imageQuality}
                  onChange={(event) =>
                    setImageQuality(event.target.value)
                  }
                  disabled={generating || generatingVariants}
                  className="mt-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
                >
                  <option value="low">
                    Low — testing
                  </option>

                  <option value="medium">
                    Medium — balanced
                  </option>

                  <option value="high">
                    High — final quality
                  </option>
                </select>

                <p className="mt-1 text-xs text-gray-500">
                  Applies to Creative #1 and all variants.
                </p>
              </div>

              <button
                type="button"
                onClick={handleGenerate}
                disabled={generating || !calloutsFinalized}
                className="rounded-lg bg-gray-900 px-6 py-3 text-sm font-medium text-white transition hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {generating
                  ? 'Generating Creative...'
                  : calloutsFinalized
                    ? 'Generate Creative'
                    : 'Finalize Callouts First'}
              </button>

            </div>
          </div>
        </div>
      )}

      {/* Generated creative */}
      {generatedCreative && (
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="mb-5 flex items-center justify-between gap-4">
            <div>
              <h2 className="text-lg font-semibold text-gray-900">
                Generated Creative
              </h2>

              <p className="mt-1 text-sm text-gray-500">
                The final creative has been saved permanently.
              </p>
            </div>

            {generatedCreative.image_url && (
              <a
                href={generatedCreative.image_url}
                download
                target="_blank"
                rel="noreferrer"
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
              >
                Download
              </a>
            )}
          </div>

          {generatedCreative.image_url && (
            <div className="flex justify-center">
              <img
                src={generatedCreative.image_url}
                alt={concept?.headline || 'Generated advertising creative'}
                className="max-h-[760px] w-auto rounded-lg border border-gray-200 shadow-sm"
              />
            </div>
          )}


          {generatedCreative.facebook_post && (
            <div className="mt-6 rounded-xl border border-gray-200 bg-gray-50 p-5">
              <div className="mb-3 flex items-center justify-between gap-3">
                <h3 className="text-sm font-semibold text-gray-900">
                  Facebook Post
                </h3>

                <button
                  type="button"
                  onClick={() =>
                    copyFacebookPost(
                      generatedCreative.facebook_post,
                      'original'
                    )
                  }
                  className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-xs font-medium text-gray-700 transition hover:bg-gray-50"
                >
                  {facebookCopied === 'original'
                    ? 'Copied'
                    : 'Copy'}
                </button>
              </div>

              <div className="whitespace-pre-wrap text-sm leading-6 text-gray-700">
                {generatedCreative.facebook_post}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Create variants */}
      {generatedCreative && (
      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h3 className="text-base font-semibold text-gray-900">
              Create Variants
            </h3>

            <p className="mt-1 text-sm text-gray-500">
              Generate additional creative directions from Creative #1.
              The product, audience and core message remain locked.
            </p>
          </div>

          <div className="flex items-end gap-3">
            <div>
              <label
                htmlFor="variantCount"
                className="block text-xs font-medium text-gray-600"
              >
                Variants
              </label>

              <select
                id="variantCount"
                value={variantCount}
                onChange={(event) =>
                  setVariantCount(Number(event.target.value))
                }
                disabled={generatingVariants}
                className="mt-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-gray-900 focus:ring-1 focus:ring-gray-900"
              >
                {[1, 2, 3, 4, 5, 6, 7, 8].map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>
            </div>

            <button
              type="button"
              onClick={handleGenerateVariants}
              disabled={generatingVariants}
              className="rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {generatingVariants
                ? `Generating ${variantProgress.current} of ${variantProgress.total}...`
                : 'Create Variants'}
            </button>
          </div>
        </div>

        {generatingVariants && (
          <div className="mt-4">
            <div className="h-2 w-full overflow-hidden rounded-full bg-gray-100">
              <div
                className="h-full rounded-full bg-gray-900 transition-all duration-500"
                style={{
                  width: `${
                    variantProgress.total > 0
                      ? (variantProgress.current /
                          variantProgress.total) *
                        100
                      : 0
                  }%`,
                }}
              />
            </div>

            <p className="mt-2 text-sm font-medium text-gray-700">
              {variantProgress.current} of {variantProgress.total} variants completed.
              {activeVariantNumber !== null && (
                <> Currently generating variant {activeVariantNumber} of {variantProgress.total}.</>
              )}
            </p>
            <p className="mt-1 text-xs text-gray-500">
              Completed creatives appear below as soon as they are saved. You can
              keep this page open while the remaining variants are generated.
            </p>
          </div>
        )}
      </div>
      )}

      {variantCreatives.length > 0 && (
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="mb-5">
            <h2 className="text-lg font-semibold text-gray-900">
              Creative Variants
            </h2>

            <p className="mt-1 text-sm text-gray-500">
              {variantCreatives.length} additional creative
              {variantCreatives.length === 1 ? '' : 's'} generated from
              Creative #1.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {variantCreatives.map((creative, index) => (
              <div
                key={
                  creative.id ||
                  creative.filename ||
                  creative.image_url ||
                  index
                }
                className="overflow-hidden rounded-xl border border-gray-200 bg-white"
              >
                {creative.image_url && (
                  <div className="bg-gray-50">
                    <img
                      src={creative.image_url}
                      alt={`Creative Variant ${index + 1}`}
                      className="mx-auto block h-auto w-full"
                    />
                  </div>
                )}

                <div className="flex items-center justify-between gap-3 p-4">
                  <div>
                    <div className="text-sm font-semibold text-gray-900">
                      Variant {index + 1}
                    </div>

                    {creative.concept?.creative_concept && (
                      <div className="mt-1 line-clamp-2 text-xs text-gray-500">
                        {creative.concept.creative_concept}
                      </div>
                    )}
                  </div>

                  {creative.image_url && (
                    <a
                      href={creative.image_url}
                      download
                      target="_blank"
                      rel="noreferrer"
                      className="shrink-0 rounded-lg border border-gray-300 px-3 py-2 text-xs font-medium text-gray-700 transition hover:bg-gray-50"
                    >
                      Download
                    </a>
                  )}
                </div>


                {creative.facebook_post && (
                  <div className="border-t border-gray-200 bg-gray-50 p-4">
                    <div className="mb-3 flex items-center justify-between gap-3">
                      <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                        Facebook Post
                      </h4>

                      <button
                        type="button"
                        onClick={() =>
                          copyFacebookPost(
                            creative.facebook_post,
                            `variant-${index}`
                          )
                        }
                        className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-xs font-medium text-gray-700 transition hover:bg-gray-50"
                      >
                        {facebookCopied === `variant-${index}`
                          ? 'Copied'
                          : 'Copy'}
                      </button>
                    </div>

                    <div className="whitespace-pre-wrap text-sm leading-6 text-gray-700">
                      {creative.facebook_post}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
   </Layout>
  );
}

function EditableConceptField({
  label,
  value,
  onChange,
  emphasis = false,
}) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
        {label}
      </div>

      <textarea
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        rows={label === 'Headline' ? 2 : 3}
        className={`mt-2 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm leading-6 text-gray-900 outline-none transition focus:border-gray-500 focus:ring-1 focus:ring-gray-500 ${
          emphasis ? 'font-semibold' : ''
        }`}
      />
    </div>
  );
}
